window.addEventListener('resize', () => {
	const body = document.body;

	// Nur ausführen, wenn data-mode="development" im Body gesetzt ist
	if (body.getAttribute('data-mode') === 'development') {
		const anchor = window.location.hash;

		if (anchor) {
			setTimeout(() => {
				const target = document.querySelector(anchor);
				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});
				}
			}, 200);
		}
	}
});
